import knowledgeServiceApi from '../api/knowledge.service.api';
import userService from './user.service';
import { getAssetsServiceBaseURL } from '../constants/APIconstants';
import { KNOWLEDGE_TYPES } from '../constants';

const HTTP_UNPROCESSABLE_ENTITY = 422;

class UploadService {
  async uploadFile({ file, onUploadProgress }) {
    const { type, size, name } = file;

    const res = await knowledgeServiceApi.getUploadUrl({ type, size, name });

    if (res.error) {
      return { error: res.error.message };
    }

    const { url, id: assetId, type: knowledgeType, fileUrl } = res.data;

    if (!fileUrl) {
      return { error: 'Failed to get upload url' };
    }

    await knowledgeServiceApi.uploadDirectlyToGCS(url, file, onUploadProgress);

    const region = userService.region;

    return {
      url: `${getAssetsServiceBaseURL(region)}${fileUrl}`,
      assetId,
      type: knowledgeType,
    };
  }

  async finalizeUploadFile({ assetId }) {
    const res = await knowledgeServiceApi.finalizedUploadFile({ id: assetId });

    if (res.error) {
      return { error: res.error.message };
    }

    return res.data;
  }

  async convertAssetToPdf({ assetId }) {
    const res = await knowledgeServiceApi.convertAssetToPdf({ assetId });

    if (res.error) {
      // assets-service answers a non-convertible document with an HTML error page, so the
      // reason can only be recognized from the status — not from a message in the body.
      // Read the axios error directly: the shared httpStatus helper takes the whole
      // Executer result on master but the error on development, so it can't be used here.
      if (res.error?.response?.status === HTTP_UNPROCESSABLE_ENTITY) {
        return { error: 'conversion-failed' };
      }

      return { error: res.error.message };
    }

    return res.data;
  }

  async triggerOcr({ assetId }) {
    const res = await knowledgeServiceApi.triggerOcrConversion({ assetId });

    if (res.error) {
      throw new Error(res.data.message);
    }

    return res.data;
  }

  async fetchOcrData({ assetId }) {
    const res = await knowledgeServiceApi.fetchOcrData({ assetId });

    if (res.error) {
      throw new Error(res.data.message);
    }

    return res.data?.task;
  }

  async retroOcrConversion({ itemId }) {
    const res = await knowledgeServiceApi.getKnowledgeItemAsset({ itemId });

    if (res.error) {
      throw new Error(res.data.message);
    }

    const { asset } = res.data;

    if (!asset) {
      throw new Error('No asset found');
    }

    // only pdf is supported for now
    const assetType = KNOWLEDGE_TYPES.PDF;

    return { assetId: asset.id, url: asset.url, type: assetType };
  }

  async rejectDuplicatedItem({ assetId }) {
    await knowledgeServiceApi.rejectDuplicatedItem({ id: assetId });
  }
}

export default new UploadService();
